import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import Message from '../Message/Message';

class ImageCropperWrapper extends Component {
    constructor(props) {
        super(props);   
        this.ratio = (this.props.ratio) ? this.props.ratio : 8 / 12;
        this.width = (this.props.width) ? this.props.width : 100;
        this.state = {
            crop: {
              x: 0,
              y: 0,
              aspect: this.ratio
            },
            image: null,
            base64Image: null,
            croppedImage: null,
            invalidImage: false
        }
    }

    componentWillMount() {
        console.log(this.props.imgSrc);

        if (this.props.imgSrc === '') {
            console.log("invalid image");
            this.setState({ invalidImage: true });
        }
    }

    componentWillUnmount() {
        console.log("componentWillUnmount");
        this.setState({ invalidImage: false });
    }

    onImageLoaded = (image) => {
        console.log("onImageLoaded", image);
        const crop = makeAspectCrop({
            x: 0,
            y: 0,
            aspect: this.state.crop.aspect,
            width: this.width,
        }, image.naturalWidth / image.naturalHeight );

        const pixelCrop = {
            x: Math.round(image.naturalWidth * (crop.x / 100)),
            y: Math.round(image.naturalHeight * (crop.y / 100)),
            width: Math.round(image.naturalWidth * (crop.width / 100)),
            height: Math.round(image.naturalHeight * (crop.height / 100))
        }

        this.setState({
            crop: crop,
            image: image
        });

        this.onCropComplete(crop, pixelCrop, image);
    }

    onCropComplete = (crop, pixelCrop, image) => {
        let canvas = document.createElement('canvas');
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        let ctx = canvas.getContext('2d');
        let img = (image) ? image : this.state.image;

        ctx.drawImage(
            img,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );

        // Base64
        const base64Image = canvas.toDataURL('image/jpeg');
        this.setState({ base64Image });
        
        // As a blob
        canvas.toBlob((blob) => {
            this.setState({ croppedImage: blob });
            this.props.updateImagePreview(base64Image, this.state.croppedImage);
        }, 'image/jpeg');
    }

    onCropChange = (crop) => {
        this.setState({ crop });
    }

    render() {
        return (
            <div>
                {this.state.invalidImage &&
                <Message
                    message={
                        {
                            title: window.general_strings.msg.warning,
                            content: window.general_strings.msg.invalidImage,
                            type: 'error'
                        }
                    }
                />
                }
                <ReactCrop 
                    src={this.props.imgSrc}
                    onImageLoaded={this.onImageLoaded}
                    onComplete={this.onCropComplete}
                    onChange={this.onCropChange}
                    crop={this.state.crop}
                />
            </div>
        );
    }
}

export default ImageCropperWrapper;



// WEBPACK FOOTER //
// ./src/components/Common/ImageCropperWrapper/ImageCropperWrapper.js